import cnpj from './cnpj'
import cpf from './cpf'
import cpfOrCnpj from './cpfOrCnpj'
import file from './file'
import form from './form'
import hasLetters from './hasLetters'
import isClear from './isClear'
import jodit from './jodit'
import multiSelect from './multiSelect'
import phone from './phone'

export default {
  cnpj,
  cpf,
  cpfOrCnpj,
  file,
  form,
  hasLetters,
  isClear,
  jodit,
  multiSelect,
  phone,
}
